import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { getReleaseDetails } from "../../api/otherEndPoints/settings";
import { Button } from "primereact/button";
import jsPDF from "jspdf";
import ImageExport from "../base64_images/feedsense_image";
import moment from "moment";
import './settings.css';

const Settings = () => {
    const [data, setData] = useState<any>([]);
    const getReleaseTableDetails = async () => {
        let response = await getReleaseDetails()
        if (response?.length >= 0){
            setData(response);
        }
    }
    function addWaterMark(doc: any) {
        var totalPages = doc.internal.getNumberOfPages();  
        for (let i = 1; i <= totalPages; i++) {
          doc.setGState(new doc.GState({opacity: 0.7}));
          doc.setPage(i);
          doc.setFontSize(48)
          doc.setFont('Helvetica', 'bold')
          doc.setTextColor(230,230,230);
          doc.text('FeedSense AI', 160,160, null, 45, 'center');
        }  
        return doc;
    }

    const addFooters = (doc: any) => {
        const pageCount = doc.internal.getNumberOfPages()
        doc.setFont('helvetica', 'italic')
        doc.setTextColor(0,0,0);
        doc.setFontSize(10)
        for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)
        doc.text('Page ' + String(i) + ' of ' + String(pageCount),260,200)
        if(i == pageCount){
            doc.setFont('Helvetica', 'italic')
            doc.text('Disclaimer: We are using statistical and artificial models etc. which are never error-free. Please apply your own discretions while using this information.',10,200)
        }
        }
    }
    const exportPdfComparison = (e:any) => {
        // console.log(e['newer_rac'])
        let data:any = []
        if(e['n_earlier_total_trades'] == null && e['n_earlier_max_drawdown_actual'] == null && e['earlier_rac'] == null){
            data = [{
                "Version": "Current Version",
                "Return After Cost": e['newer_rac'],
                "Max Drawdown" : e['n_newer_max_drawdown_actual'],
                "Total Trades" : e['n_newer_total_trades']
            }]
        }
        else{
            data = [{
                "Version": "Current Version",
                "Return After Cost": e['newer_rac'],
                "Max Drawdown" : e['n_newer_max_drawdown_actual'],
                "Total Trades" : e['n_newer_total_trades']
            }
            ,
            {
                "Version": "Previous Version",
                "Return After Cost" : e['earlier_rac'],
                "Max Drawdown" : e['n_earlier_max_drawdown_actual'],
                "Total Trades" : e['n_earlier_total_trades']
            }]
        }
        let exportCols = [{title: 'Version',dataKey : 'Version'}, 
            {title: 'Return After Cost',dataKey: 'Return After Cost'}, 
            {title: 'Max Drawdown',dataKey: 'Max Drawdown'},
            {title: 'Number of Trades', dataKey: 'Total Trades'}
        ]
        var doc = new jsPDF('l');
         var image = ImageExport()
            // doc.addImage(image, 'PNG',125, 10, 50, 15);
            const imageWidth = 50;
            const imageHeight = 15;
            const pageWidth = doc.internal.pageSize.getWidth();
            const imageX = (pageWidth - imageWidth) / 2;
            doc.setFont('Lato-Regular', 'bold')
            doc.setFontSize(13)
            doc.text(`${e['s_symbol']} | ${e['s_code']} | Annual Performance (${e['start']} - ${e['end']}) | Release Note - ${moment(e['dt_date']).format("DD MMM YYYY")}`, 145, 35, { align: 'center'});
            (doc as any).autoTable(exportCols, data, {
              styles: {
                halign: 'left'
            },
            startY: 40,
            margin: { top: 30 },
            didDrawPage: (data: any) => {
              // Draw image in header (every page)
              doc.addImage(image, 'PNG', imageX, 8, imageWidth, imageHeight);
        
              // Horizontal line
              doc.setLineWidth(0.1);
              doc.line(10, 25, pageWidth - 10, 25);
            },
            headStyles : {lineWidth: 0.5,fillColor: [224, 224, 224],textColor: [0,0,0]},
            theme: 'grid',
          }
         );
        doc = addWaterMark(doc)
        addFooters(doc)
        doc.save(`FeedSense AI | Release Note |  ${e['mapping_symbol']}.pdf`);
    }

    useEffect (() => {
        getReleaseTableDetails()
    }, [])


    return (
        <>
        <div className="release-header"><h4>RELEASE NOTES</h4></div>
        <div className="row card-body release-tbl">
            <div className="table-settings">
                <DataTable value={data} scrollable >
                    <Column 
                        style={{width:'120px', textAlign: 'left'}} 
                        header='Symbol' 
                        body={(e:any) => <>
                                <div className='hovertext hover-settings' data-hover={e?.s_code? e?.s_code: e?.s_symbol}>{e?.s_symbol}</div>
                                <div>({e.mapping_code})</div></>
                            }>
                    </Column>

                    <Column 
                        style={{width:'200px', textAlign: 'left'}} 
                        field='dt_date' 
                        sortable 
                        header='Release Date' 
                        body={(e:any) => 
                            <div>{moment(e?.dt_date).format("DD MMM YYYY")}</div>
                            }>
                    </Column>
                    
                    <Column 
                        style={{width:'200px', textAlign: 'left'}} 
                        header='Remarks' 
                        body={(e:any) => 
                            <div>
                                {
                                    e?.s_remark ? ((e?.s_remark).charAt(0).toUpperCase() + (e?.s_remark).slice(1)) : ''
                                }
                            </div>
                        }
                        >
                    </Column>
                    
                    <Column 
                        style={{width:'70px', textAlign: 'left'}} 
                        field="" 
                        header = 'Release  Notes' 
                        body = { (e:any) => 
                                        <>
                                        {e?.s_code? 
                                            <><Button type="button" icon="pi pi-file-pdf" rounded onClick={() => exportPdfComparison(e)} className='button1' /></> : <></>
                                        }
                                        </>
                            }>
                    </Column>

                </DataTable>
            </div>
        </div>
        </>
    )
}
export default Settings;